<section class="home-wrapper">

  <!-- MAIN CONTENT (70%) -->
  <main class="home-main">

    <!-- HERO -->
    <section class="home-section">
      <h1 class="page-title">
        Daily City Updates – Traffic, Petrol Price & Gold Rate Today
      </h1>

      <p class="page-intro">
        DailyCity helps you stay informed with today’s city updates including traffic
        conditions, power cuts, petrol price, gold rate and important alerts.
      </p>
    </section>

    <!-- CITY LIST -->
    <section class="city-section">
      <h2 class="section-title">Today Updates by City</h2>

      <div class="city-grid">
        <article class="city-card" *ngFor="let c of todayCities">
          <h3 class="city-title">
            <a [routerLink]="['/', c.slug]">{{ c.city }} Today</a>
          </h3>

          <p class="city-desc">{{ c.description }}</p>

          <a class="read-link" [routerLink]="['/', c.slug]">
            View updates →
          </a>
        </article>
      </div>
    </section>

    <!-- ABOUT -->
    <section class="editorial-section">
      <h2>Why DailyCity Exists</h2>
      <p>
        In fast-growing Indian cities, access to accurate daily information
        is essential. From fuel price changes to traffic congestion and
        power maintenance schedules, small updates impact everyday life.
      </p>

      <p>
        DailyCity brings together verified city-level information such as
        traffic conditions, petrol prices, gold rates, power cut alerts
        and Panchang details in one easy-to-access platform.
      </p>

      <p>
        Our goal is to help users plan their day efficiently with reliable
        and timely updates tailored for their city.
      </p>
    </section>


  </main>

  <!-- SIDEBAR (30%) -->
  <app-sidebar></app-sidebar>
  <!-- <aside class="news-sidebar">

    <div class="sidebar-card">
      <h3>What you’ll find</h3>
      <ul>
        <li>🚦 Daily traffic updates</li>
        <li>⛽ Petrol & diesel prices</li>
        <li>🥇 Gold & silver rates</li>
        <li>⚡ Power & water alerts</li>
      </ul>
    </div>

    <div class="sidebar-card">
      <h3>Why DailyCity?</h3>
      <p>
        One simple place for essential daily city information — fast, accurate,
        and updated every day.
      </p>
    </div>

       <div class="sidebar-card">
      <h3>Popular Today</h3>
      <ul>
        <li><a routerLink="/chennai-today">Chennai Today</a></li>
        <li><a routerLink="/bangalore-today">Bangalore Today</a></li>
        <li><a routerLink="/hyderabad-today">Hyderabad Today</a></li>
        <li><a routerLink="/mumbai-today">Mumbai Today</a></li>
      </ul>
    </div>

    <div class="sidebar-card">
      <h3>Quick Updates</h3>
      <ul>
        <li><a routerLink="/gold-rate">Gold Rate Today</a></li>
        <li><a routerLink="/petrol-price">Petrol Price Today</a></li>
        <li><a routerLink="/power-cut">Power Cut Updates</a></li>
      </ul>
    </div>

    <div class="sidebar-card ad-box">
      <ins class="adsbygoogle"
           style="display:block"
           data-ad-client="ca-pub-XXXX"
           data-ad-slot="3333333333"
           data-ad-format="auto"
           data-full-width-responsive="true">
      </ins>
    </div>

  </aside> -->

</section>